import React, { useEffect, useState } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
import error from "assets/images/error-img.png";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import DeleteModal from "components/Common/DeleteModal";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Select from "react-select";
import Language from "Enums/Language";
import AdminsService from "services/Admin/AdminsService";
import RolesService from "services/Admin/RolesService";

function ModalForm({
	modal,
	toggle,
	editAdmin,
	setEditAdmin,
	setShouldGetData,
	setShowSuccessModal,
}) {
	const [email, setEmail] = useState(editAdmin ? editAdmin.email : "");
	const [name, setName] = useState(editAdmin ? editAdmin?.name || "" : "");
	const [loading, setLoading] = useState(false);
	const [roles, setRoles] = useState();
	const [selectedRole, setSelectedRole] = useState(
		editAdmin
			? {
					value: editAdmin.role.id,
					label: editAdmin.role.name.en,
			  }
			: null
	);
	const adminsService = new AdminsService();
	const rolesService = new RolesService();
	useEffect(() => {
		rolesService.getDropDown().then((res) => {
			const newOptions = res.data.map((item) => {
				return {
					label: item.name.en,
					value: item.id,
				};
			});
			setRoles(newOptions);
		});
	}, []);

	const handleValidSubmit = (e, values) => {
		const data = {
			name: values.name,
			email: values.email,
			role_id: selectedRole?.value,
		};
		if (!selectedRole) {
			toast.error("please enter the role of the admin");
			return;
		}
		setLoading(true);
		if (editAdmin) {
			adminsService
				.update(editAdmin.id, data)
				.then((response) => {
					if (response && response.status === SuccessOk) {
						toast.success("Update Role successfully");
						setShouldGetData(true);
						toggle();
						setEditAdmin(null);
					} else {
						setLoading(false);
					}
				})
				.catch((e) => {
					setLoading(false);
				});
		} else {
			adminsService
				.inviteAdmin(data)
				.then((response) => {
					if (response && response.status === SuccessOk) {
						// toast.success("invitation sent successfully")
						setShouldGetData(true);
						toggle();
						setShowSuccessModal(true);
					} else {
						setLoading(false);
					}
				})
				.catch((e) => {
					setLoading(false);
				});
		}
	};
	return (
		<Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
			<ModalHeader className="border-0" toggle={toggle}>
				Assign An Admin
				<p className="textMuted  font-weight-normal pt-2 font-size-13">
					Assign an admin to can manage the properties and sales rep
				</p>
			</ModalHeader>
			<ModalBody className="pt-0">
				<AvForm
					className="form-horizontal formWithLabel"
					onValidSubmit={(e, v) => {
						handleValidSubmit(e, v);
					}}>
					<Row>
						<Col md={12}>
							<AvField
								className="mb-3 font-size-14"
								name="name"
								label="Name"
								bsSize="lg"
								required
								type="text"
								placeholder="Name"
								value={name}
								onChange={(e) => setName(e.target.value)}
							/>
							<AvField
								className="mb-3 font-size-14"
								name="email"
								label="Email Address"
								bsSize="lg"
								required
								type="email"
								placeholder="Email Address"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								disabled={editAdmin}
							/>
							<div className="d-sm-flex editSelectLabel">
								<label>Role</label>
								<Select
									required
									name="Role"
									placeholder="Select"
									options={roles}
									className="mb-3 w-100 btnHeight"
									onChange={(data) => {
										setSelectedRole(data);
									}}
									value={selectedRole}
								/>
							</div>
						</Col>
					</Row>
					<div className="px-0 border-0 pt-2">
						<button
							disabled={loading ? true : false}
							type="submit"
							className="btn btn-success w-100">
							{editAdmin ? "Update" : "Send an"} invitation
						</button>
					</div>
				</AvForm>
			</ModalBody>
		</Modal>
	);
}

export default ModalForm;
